import React, { useEffect, useMemo, useState } from "react";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../comman/Sidebar";
import CustomerFilterModel from "../model/CustomerFilterModel";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import {
  Checkbox,
  Grid,
  Input,
  InputAdornment,
  ListItemText,
  Stack,
  Button,
  FormControlLabel,
  CircularProgress,
  PaginationItem,
  Icon,
  TableSortLabel,
  Autocomplete,
  TextField,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  GET_ALL_BILLING_FILTER_URL,
  CREATE_UPDATE_BILLING_STATEMENT_URL,
  GET_ALL_PROJECT_FILTER_URL,
} from "../../constants/ApiRoute";
import {
  authHeader,
  getLogUserId,
  getLogUserRole,
} from "../comman/MainFunction";
import API from "../comman/API";

import Pagination from "@mui/material/Pagination";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  CUSTOMER_HISTORY,
  ADD_CUSTOMER,
  ADMIN_BILLING_HISTORY,
  BILLING_STATEMENT_LIST_ROUTE,
  ADMIN_BILLING_LIST,
} from "../../constants/RoutePath";
import UserClearFilter from "../model/UserClearFilter";
import CustomPageLoading from "../comman/CustomPageLoading";
import Navbar from "../comman/Navbar";
import CreateBillingConfirm from "./CreateBillingConfirm";
import BillingStatementMenu from "../comman/BillingStatementMenu";
import {
  getAllCustomersList,
  getAllProjectsList,
  getPerDiemList,
} from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AdminBillingStatementFilter from "../model/AdminBillingStatementFilter";
import { useToast } from "../comman/CustomMessages";
import BillingNodata from "../../images/billing-nodata.svg";
import NoRecordFound from "../comman/NoRecordFound";
import * as types from "../../redux/action/ActionType";

const moment = require("moment");
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const filterInitial = {
  customerStatus: "",
  projectStatus: "",
  userId: "",
  projectId: "",
};

const billingFilterInitial = {
  billingStartDateDatepicker: "",
  billingEndDateDatepicker: "",
  billingStartDate: "",
  billingEndDate: "",
  broker: [],
};
const selectAdminBillingFilter = (state) => state.AdminBillingStatementFilter;

const AdminBillingList = () => {
  const currentSort = useSelector((r) => r.SortReducer);
  const [loading, setLoading] = useState(false);
  const [isBillingStatementSearch, setIsBillingStatementSearch] =
    useState(false);
  const [list, setList] = useState([]);
  const showToast = useToast();
  const [total, setTotal] = useState(10);
  const [page, setPage] = useState(0);
  const theme = useTheme();
  const [customerName, setCustomerName] = React.useState([]);
  const [personName, setPersonName] = React.useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const [filter, setFilter] = React.useState(filterInitial);
  const [billingfilter, setBillingFilter] =
    React.useState(billingFilterInitial);
  const [clearFlag, setClearFlag] = useState(false);
  const [clearFiltervalue, setClearFilterValue] = useState(false);
  const [search, setSearch] = React.useState([]);
  const [applyFilterFlag, setApplyFilterFlag] = React.useState(false);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const [userList, setUserList] = useState([]);
  const userListSel = deCryptFun(useSelector((s) => s.AllCustomerListReducer));
  const reduxFilter = useSelector(selectAdminBillingFilter);
  const [billingStateOrderBy, setBillingStateOrderBy] = useState("");
  const [billingStateOrder, setBillingStateOrder] = useState("asc");

  console.log(reduxFilter, "reduxxxxxxxxxxxxxxxxx");
  console.log(filter, "filterreduxxxxxxxxxxxxxxxxx");
  // const projectListSel = deCryptFun(
  //   useSelector((s) => s.AllProjectListReducer)
  // );
  // const projectList = projectListSel ? JSON.parse(projectListSel).data : [];

  const getLogUserRoleArray = JSON.parse(getLogUserRole());
  var getLogUserRoleBoolean = false;
  if (
    getLogUserRoleArray &&
    getLogUserRoleArray.length > 0 &&
    getLogUserRoleArray.length === 1 &&
    getLogUserRoleArray[0] == "Admin"
  ) {
    getLogUserRoleBoolean = true;
  }

  const [periods, setPeriods] = useState([]);
  const [count, setCount] = useState(100);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [projectListDropdown, setProjectListDropdown] = useState([]);
  const [billingStatmentLoading, setBillingStatementLoading] = useState(true);
  const [startMonth, setStartMonth] = useState("");
  const [numberOfMonths, setNumberOfMonths] = useState("");
  const [billPeriod, setBillPeriod] = useState("");
  const navigate = useNavigate();
  console.log(projectList, "projectListperiodsperiodsperiods");
  const currentMonthNumber = moment().month() + 1;

  const handleFilterChange = (event, value) => {
    setBillingFilter(billingFilterInitial); // Reset filter
    setBillingStatementLoading(true); // Set loading state to true

    const { name, value: inputValue } = event.target;

    if (name === "projectId") {
      // When projectId is changed, make sure to call getPerDiemList
      dispatch(getPerDiemList(inputValue)); // API call to fetch Per Diem list

      // Find the selected project from the projectList to get the billing period
      const selectedProject = projectList?.find(
        (element) => element.ProjectId === inputValue
      );

      setBillPeriod(selectedProject?.BillingPeriod || 0); // Set the billing period if exists

      // Update filter state with the selected projectId
      setFilter((prevState) => ({
        ...prevState,
        projectId: inputValue,
        filterValues: {},
      }));

      // Dispatch updated filter to the store
      dispatch({
        type: types.ADMIN_BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          projectId: inputValue,
          filterValues: {},
        },
      });
    }

    if (name === "userId") {
      // When userId is changed, reset the project list and dropdown
      setProjectList([]);
      setProjectListDropdown([]);

      // Update filter state with the selected userId
      setFilter((prevState) => ({
        ...prevState,
        userId: inputValue,
        projectId: "", // Reset projectId because the user changed
        filterValues: {},
      }));

      // Dispatch updated filter state with the selected userId
      dispatch({
        type: types.ADMIN_BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          userId: inputValue,
          projectId: "", // Reset projectId due to user change
          filterValues: {},
        },
      });

      // Trigger API call to fetch the project list based on the selected user
      getProjectList(inputValue); // API call to fetch projects for the user
    }

    // Handle case when the customer is selected in the Autocomplete (userId)
    if (!name && value) {
      // If a user is selected, update filter state
      const selectedUser = userList.find((user) => user.UserId === value);

      if (selectedUser) {
        setFilter((prevState) => ({
          ...prevState,
          userId: value,
          filterValues: {},
        }));

        // Dispatch updated filter to the store
        dispatch({
          type: types.ADMIN_BILLING_STATEMENT_SELECT,
          payload: {
            ...filter,
            userId: value,
            filterValues: {},
          },
        });

        // Trigger the API call to fetch the project list based on the selected user
        getProjectList(value);
      }
    } else {
      // If no user is selected (value is null or cleared), reset the filter and project list
      setFilter((prevState) => ({
        ...prevState,
        userId: "",
        filterValues: {},
      }));
      dispatch({
        type: types.ADMIN_BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          userId: "",
          filterValues: {},
        },
      });

      // Reset project list and dropdown
      setProjectList([]);
      setProjectListDropdown([]);
    }
  };

  const handleFilterChange1 = (event, value) => {
    // Handle project change and update filter state as needed
    setBillingStatementLoading(true);

    if (value) {
      setFilter((prevState) => ({
        ...prevState,
        projectId: value.ProjectId,
        filterValues: {},
      }));

      dispatch({
        type: types.ADMIN_BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          projectId: value.ProjectId,
          filterValues: {},
        },
      });
    } else {
      // Reset filter values if no project is selected
      setFilter((prevState) => ({
        ...prevState,
        projectId: "",
        filterValues: {},
      }));

      dispatch({
        type: types.ADMIN_BILLING_STATEMENT_SELECT,
        payload: {
          ...filter,
          projectId: "",
          filterValues: {},
        },
      });
    }
  };

  // const handleFilterChange = (event) => {
  //   setBillingFilter(billingFilterInitial);
  //   setBillingStatementLoading(true);
  //   const { name, value } = event.target;

  //   if (name === "projectId") {
  //     dispatch(getPerDiemList(value));
  //     const selectedProject =
  //       projectList &&
  //       projectList.length > 0 &&
  //       projectList.find((element) => element.ProjectId === value);
  //     setBillPeriod(
  //       selectedProject?.BillingPeriod ? selectedProject?.BillingPeriod : 0
  //     );
  //     setFilter((prevState) => ({
  //       ...prevState,
  //       projectId: value,
  //       filterValues: {},
  //     }));
  //     dispatch({
  //       type: types.ADMIN_BILLING_STATEMENT_SELECT,
  //       payload: {
  //         ...filter,
  //         projectId: value, // Assuming 'value' is the new project ID you want to set
  //         filterValues: {},
  //       },
  //     });
  //   }

  //   if (name === "userId") {
  //     setProjectList([]);
  //     setProjectListDropdown([]);
  //     setFilter((prevState) => ({
  //       ...prevState,
  //       userId: value,
  //       projectId: "",
  //       filterValues: {},
  //     }));
  //     dispatch({
  //       type: types.ADMIN_BILLING_STATEMENT_SELECT,
  //       payload: {
  //         ...filter,
  //         userId: value,
  //         projectId: "", // Assuming 'value' is the new project ID you want to set
  //         filterValues: {},
  //       },
  //     });
  //     getProjectList(value);
  //   }
  //   // else {
  //   //   setFilter((prevState) => ({
  //   //     ...prevState,
  //   //     [name]: value,
  //   //   }));
  //   // }
  // };
  const handleCustomerProjectStatusChange = (name, val) => {
    setBillingFilter(billingFilterInitial);
    let value = "";
    if (val === "yes") {
      value = true;
    } else if (val === "no") {
      value = false;
    }

    if (name === "customerStatus") {
      const updatedFilter = {
        ...filter,
        userId: "",
        projectId: "",
        projectStatus: "",
        customerStatus: value,
        filterValues: {},
      };
      setFilter(updatedFilter);

      dispatch({
        type: types.ADMIN_BILLING_STATEMENT_SELECT,
        payload: updatedFilter,
      });

      setProjectList([]);
      setProjectListDropdown([]);

      let userListDropdown = [];
      if (
        userListSel &&
        JSON.parse(userListSel).data &&
        JSON.parse(userListSel).data.length > 0
      ) {
        userListDropdown = JSON.parse(userListSel).data;
      }

      if (value === "") {
        setUserList(userListDropdown);
      } else if (value === true) {
        const activeUsers =
          userListDropdown.length > 0 &&
          userListDropdown.filter((item) => item.Active === 1);
        setUserList(activeUsers);
      } else if (value === false) {
        const inActiveUsers =
          userListDropdown.length > 0 &&
          userListDropdown.filter((item) => item.Active === 0);
        setUserList(inActiveUsers);
      }
    }

    if (name === "projectStatus") {
      const updatedFilter = {
        ...filter,
        projectId: "",
        projectStatus: value,
        filterValues: {},
      };
      setFilter(updatedFilter);

      dispatch({
        type: types.ADMIN_BILLING_STATEMENT_SELECT,
        payload: updatedFilter,
      });

      if (value === "") {
        setProjectList(projectListDropdown);
      } else if (value === true) {
        const activeProjects =
          projectListDropdown.length > 0 &&
          projectListDropdown.filter((item) => item.Active === 1);
        setProjectList(activeProjects);
      } else if (value === false) {
        const inActiveProjects =
          projectListDropdown.length > 0 &&
          projectListDropdown.filter((item) => item.Active === 0);
        setProjectList(inActiveProjects);
      }
    }
  };

  const clearBillingFilterFunc = () => {
    setBillingFilter(billingFilterInitial);
    setApplyFilterFlag(false);
    dispatch({
      type: types.ADMIN_BILLING_STATEMENT_SELECT,
      payload: {
        ...filter,
        filterValues: billingFilterInitial,
      },
    });
    setFilter((prevState) => ({
      ...prevState,
      filterValues: billingFilterInitial,
    }));
    getBillingStatementFilterList();
  };

  const filterOpenFun = () => {
    setOpenFilter(!openFilter);
    if (openFilter) {
      setApplyFilterFlag(false);
    }
  };

  // const handlePageChange = (e, value) => {
  //   setPage(value);
  // };

  const isAlreadyCovered = (periods, dateToCheck) => {
    for (let period of periods) {
      const dates = period.billingDate.split(" - ");
      const startDate = dates[0];
      const endDate = dates[1];

      if (dateToCheck === startDate || dateToCheck === endDate) {
        return true;
      }
    }
    return false;
  };

  const generateBillingPeriods = async (
    startMonth,
    numberOfMonths,
    billPeriod,
    billingArray
  ) => {
    const periods = [];
    const year = new Date().getFullYear();

    for (let month = startMonth; month < startMonth + numberOfMonths; month++) {
      const currentMonth = ((month - 1) % 12) + 1; // Adjust month within 1-12 range
      const adjustedYear = year + Math.floor((month - 1) / 12); // Adjust year if month exceeds December

      const daysInMonth = new Date(adjustedYear, currentMonth, 0).getDate(); // Get number of days in the month
      let startDay = 1;

      while (startDay <= daysInMonth) {
        let endDay = startDay + billPeriod - 1;

        if (endDay > daysInMonth) {
          endDay = daysInMonth; // Adjust end day to the last day of the month if it exceeds the number of days in the month
        }

        // Adjust for cases where the remaining days at the end of the month are less than the billing period
        if (endDay + billPeriod > daysInMonth) {
          endDay = daysInMonth; // Set endDay to the last day of the month
        }

        // Format billing start and end dates
        const billingStart = moment(
          `${adjustedYear}-${currentMonth}-${startDay}`,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");
        const billingEnd = moment(
          `${adjustedYear}-${currentMonth}-${endDay}`,
          "YYYY-MM-DD"
        ).format("DD/MM/YYYY");

        const billingStartList = moment(
          `${adjustedYear}-${currentMonth}-${startDay}`,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY");

        const billingEndList = moment(
          `${adjustedYear}-${currentMonth}-${endDay}`,
          "YYYY-MM-DD"
        ).format("MM/DD/YYYY");

        // Check if the period is not a single day and does not overlap with the next period
        if (
          !(startDay === endDay && isAlreadyCovered(periods, billingStart)) &&
          !isAlreadyCovered(periods, billingEnd)
        ) {
          const period = `${billingStart} - ${billingEnd}`;

          let periodData = {
            billingStatementId: 0,
            userId: filter.userId,
            billingDate: period,
            billingDateList: `${billingStartList} - ${billingEndList}`,
            periodKey: dateToTimestamp(period),
            projectId: filter.projectId,
            statusId: 0,
            billingStart: `${startDay}/${currentMonth}/${adjustedYear}`,
            billingEnd: `${endDay}/${currentMonth}/${adjustedYear}`,
            hours: 0,
            dayRate: 0,
            perDiem: 0,
            lodging: "",
            miles: "",
            misc: "",
            copies: "",
            mileageRate: "",
            total: "",
            lastModified: "",
            currentMonth: currentMonthNumber === currentMonth ? true : false,
          };

          periods.push(periodData);
        }

        startDay += billPeriod;

        // Break the loop if startDay goes beyond the days in the month
        if (startDay > daysInMonth) {
          break;
        }
      }
    }

    /*
  for (let month = startMonth; month < startMonth + numberOfMonths; month++) {
    const currentMonth = ((month - 1) % 12) + 1; 
    const adjustedYear = year + Math.floor((month - 1) / 12);

    const daysInMonth = new Date(adjustedYear, currentMonth, 0).getDate();
    let startDay = 1;

    while (startDay <= daysInMonth) {
      let endDay = startDay + billPeriod - 1;

      if (endDay > daysInMonth) {
        endDay = daysInMonth;
      }

      if (endDay + billPeriod > daysInMonth) {
        endDay = daysInMonth;
      }

      const billingStart = moment(
        `${adjustedYear}-${currentMonth}-${startDay}`
      ).format("DD/MM/YYYY");
      const billingEnd = moment(
        `${adjustedYear}-${currentMonth}-${endDay}`
      ).format("DD/MM/YYYY");

      const period = `${billingStart} - ${billingEnd}`;
      let periodData = {
        billingStatementId: 0,
        userId: filter.userId,
        billingDate: period,
        periodKey: dateToTimestamp(period),
        projectId: filter.projectId,
        statusId: 0,
        billingStart: `${startDay}/${currentMonth}/${adjustedYear}`,
        billingEnd: `${endDay}/${currentMonth}/${adjustedYear}`,
        hours: 0,
        dayRate: 0,
        perDiem: 0,
        lodging: "",
        miles: "",
        misc: "",
        copies: "",
        mileageRate: "",
        total: "",
        lastModified: "",
        currentMonth: currentMonthNumber === currentMonth ? true : false,
      };
      
      periods.push(periodData);

      startDay += billPeriod;

      if (startDay > daysInMonth) {
        break;
      }
    }
  }
  */

    billingArray &&
      billingArray.length > 0 &&
      billingArray.forEach((billing) => {
        periods.forEach((dateItem) => {
          if (dateItem.periodKey === billing.PeriodKey) {
            dateItem["billingStatementId"] = billing.billingStatementId;
            dateItem["userId"] = billing.UserID;
            dateItem["periodKey"] = billing.PeriodKey;
            dateItem["projectId"] = billing.ProjectID;
            dateItem["statusId"] = billing.StatusID;
            dateItem["hours"] = billing.Hours;
            dateItem["dayRate"] = billing.DayRate;
            dateItem["perDiem"] = billing.PerDiem;
            dateItem["lodging"] = billing.Lodging;
            dateItem["miles"] = billing.Miles;
            dateItem["brokerName"] = billing.BrokerName;
            dateItem["misc"] = billing.Misc;
            dateItem["copies"] = billing.Copies;
            dateItem["mileageRate"] = billing.MileageRate;
            dateItem["total"] = billing.Total;
            dateItem["lastModified"] = billing.LastModified;
          }
        });
      });

    const periodsFinal = periods.filter((item) => item.statusId === 1);
    return periodsFinal;
  };

  const getBillingStatementDetails = async () => {
    setBillingStatementLoading(true);
    setLoading(true);
    const { userId, projectId, filterValues } = reduxFilter;
    const { billingStartDate, billingEndDate, broker } = billingfilter;
    console.log(
      filterValues,
      "836de13ae8152f19927e83fad716e9df9e35e88bb81af8e31618369a"
    );
    let data = {
      count: count,
      offset: page,
      isOrphaned: true,
    };

    // if (getLogUserRoleBoolean) {
    //   data.isOrphaned = getLogUserRoleBoolean;
    // }

    if (userId) {
      data.customerId = userId;
    }

    if (projectId) {
      data.projectId = projectId;
    }
    // if (clearFiltervalue) {
    if (billingStartDate && filterValues.billingStartDate) {
      data.billingStart = billingStartDate;
    }

    if (billingEndDate && filterValues.billingEndDate) {
      data.billingEnd = billingEndDate;
    }

    if (broker && broker.length > 0 && filterValues?.broker?.length > 0) {
      data.brokerId = broker.join(",");
    }
    // }

    const config = {
      method: "GET",
      url: GET_ALL_BILLING_FILTER_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };
    setBillingStatementLoading(true);
    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setList(parsedResponse.data);
        setTotal(Math.ceil(parsedResponse.totalCount / 10));
        // return parsedResponse.data; // Return the data for further processing
        return parsedResponse; // Return the data for further processing
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        if (v?.message?.accessDenied == 1) {
          showToast(v?.message?.message, "error");
          dispatch({
            type: types.ADMIN_BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              userId: "",
              projectId: "",
              filterValues: {},
            },
          });
          dispatch({
            type: types.BILLING_STATEMENT_SELECT,
            payload: {
              customerStatus: "",
              projectStatus: "",
              projectId: "",
              filterValues: {},
            },
          });
          setFilter(filterInitial);
          setBillingFilter(billingFilterInitial);
          navigate(ADMIN_BILLING_LIST);
        } else if (v?.message != "No record found.") {
          showToast(v?.message, "error");
        }
        setBillingStatementLoading(false);
      }
      return null; // Return null on error
    } finally {
      setLoading(false);
      setBillingStatementLoading(false);
    }
  };
  const getProjectList = async (customerId) => {
    setBillingStatementLoading(true);
    if (customerId) {
      let data = {
        count: count,
        offset: page,
        customerId: customerId,
      };

      const config = {
        method: "GET",
        url: GET_ALL_PROJECT_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };
      setBillingStatementLoading(true);
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);

        if (parsedResponse.data && parsedResponse.data.length > 0) {
          const filteredData = parsedResponse.data.map((item) => ({
            Name: item.Name,
            ProjectId: item.ProjectId,
            BillingPeriod: item.BillingPeriod,
            Active: item.Active,
          }));
          setProjectList(filteredData);
          setProjectListDropdown(filteredData);
        } else {
          setProjectList([]);
          setProjectListDropdown([]);
        }
        setBillingStatementLoading(false);
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
        }
        return null; // Return null on error
      }
    } else {
      setProjectList([]);
      setProjectListDropdown([]);
      setBillingStatementLoading(false);
    }
  };

  const billingMoveClick = (value) => {
    if (value.billingStatementId) {
      navigate(`/orphaned-statement/${value.billingStatementId}`);
    } else {
      const dateToTimestampValue = dateToTimestamp(value.billingDate);
      var dates = value.billingDate.split(" - ");

      let postData = {
        billingStatementId: 0,
        userId: getLogUserId(),
        periodKey: dateToTimestampValue,
        projectId: filter.projectId,
        statusId: 1,
        billingStart: convertDateFormat(dates[0]),
        billingEnd: convertDateFormat(dates[1]),
        hours: 0,
        dayRate: 0,
        perDiem: 0,
        lodging: "",
        miles: "",
        misc: "",
        copies: "",
        mileageRate: "",
        total: "",
        isOrphaned: true,
      };

      if (!postData.billingStatementId) {
        setSelectedPeriod(postData);
        setOpen(true);
      }
    }
  };

  const convertDateFormat = (dateStr) => {
    const parts = dateStr.split("/");
    if (parts.length !== 3) return dateStr; // Handle invalid input
  
    const formattedDate = `${parts[2]}/${parts[0].padStart(2, "0")}/${parts[1].padStart(2, "0")}`;
    return formattedDate;
  };

  const dateToTimestamp = (dateStr) => {
    var dates = dateStr.split(" - ");
    var startDateStr = dates[0];
    var endDateStr = dates[1];
    var startDateStrparts = startDateStr.split("/");
    var endDateStrparts = endDateStr.split("/");
    var startDateTimestamp = startDateStrparts.join("");
    var endDateTimestamp = endDateStrparts.join("");
    return startDateTimestamp.toString() + endDateTimestamp.toString();
  };

  const createBilling = async (value) => {
    setOpen(false);

    if (value === true && !selectedPeriod.billingStatementId) {
      const config = {
        method: "POST",
        url: CREATE_UPDATE_BILLING_STATEMENT_URL,
        headers: authHeader(),
        data: {
          webString: enCryptFun(JSON.stringify(selectedPeriod)),
        },
      };
      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          navigate(`/orphaned-statement/${parsedResponse.billingStatementId}`);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          if (v?.message?.accessDenied == 1) {
            showToast(v?.message?.message, "error");
            dispatch({
              type: types.ADMIN_BILLING_STATEMENT_SELECT,
              payload: {
                customerStatus: "",
                projectStatus: "",
                userId: "",
                projectId: "",
                filterValues: {},
              },
            });
            navigate(ADMIN_BILLING_LIST);
          } else {
            showToast(v?.message, "error");
          }
        }
      }
    }
  };

  const filterClose = () => {
    setOpenFilter(false);
  };

  const submitFilter = () => {
    setOpenFilter(false);
    setApplyFilterFlag(true);
    console.log("test submit");
  };

  const getFutureMonth = (startMonth, numberOfMonths) => {
    let targetMonth = (startMonth - numberOfMonths / 2) % 12;
    if (targetMonth < 0) {
      targetMonth += 12;
    }
    if (targetMonth === 0) {
      targetMonth = 12;
    }
    return targetMonth;
  };

  const getBillingStatementFilterList = () => {
    const selectedProject =
      projectList &&
      projectList?.length > 0 &&
      projectList.find(
        (element) => element?.ProjectId == reduxFilter?.projectId
      );
    console.log(selectedProject, "selectedProjectselectedProject", billPeriod);
    console.log(projectList, "projectListjjjjjj");
    setBillPeriod(
      selectedProject?.BillingPeriod != 0 ? selectedProject?.BillingPeriod : 0
    );
    console.log(filter, "filterrrrrrrrrrrrrr");
    if (filter.userId && filter.projectId) {
      (async () => {
        try {
          const billingStatementData = await getBillingStatementDetails();
          console.log(
            billingStatementData,
            "billingStatementDatabillingStatementData"
          );
          if (billingStatementData) {
            var billingStatementDataBilling = billingStatementData.data
              ? billingStatementData.data
              : [];
            var billingStatementDataBroker =
              billingStatementData.projectBrkerDetails
                ? billingStatementData.projectBrkerDetails
                : [];

            billingStatementDataBilling.map((item) => {
              if (
                billingStatementDataBroker &&
                billingStatementDataBroker[0] &&
                billingStatementDataBroker[0].UserID &&
                billingStatementDataBroker[0].UserID == item.UserID
              ) {
                item.DayRate = billingStatementDataBroker[0].DayRate;
                item.MileageRate = billingStatementDataBroker[0].MileageRate;
              } else if (item.brokerDayRate) {
                item.DayRate = item.brokerDayRate;
                item.MileageRate = item.projectMileageRate;
              }
            });
            const filteredValue = billingStatementDataBilling.filter(
              (item) => item.StatusID == 1
            );

            const updatedBillingData = filteredValue.map((statement) => {
              // Extract the year from the BillingEnd date
              const billingEndYear = new Date(statement.BillingEnd).getFullYear();
              const billingEndDate = new Date(statement.BillingEnd);
              const monthIndex = billingEndDate.getMonth() + 1; // getMonth() returns 0 for January, 1 for February, etc.
              
              // Return a new object with all existing properties and the new currentYear property
              return { ...statement, currentYear: billingEndYear, currentMonth: monthIndex };
            });

            console.log(updatedBillingData,'updateeeeeeeeee')
            // setPeriods(filteredValue);
            setPeriods(updatedBillingData);
            console.log(
              filteredValue,
              "filterrdddddddddddd",
              billingStatementDataBilling
            );
            // setPeriods(filteredValue);
            setIsBillingStatementSearch(true);
            setBillingStatementLoading(true);
            // const periodsFinal = billingStatementData.filter(
            //   (item) => item.StatusID
            // );
            // console.log(periodsFinal, "periodsperiodsperiods7654");
            //   const numberOfMonthsVal = 7;
            //   const billPeriodVal = selectedProject?.BillingPeriod || billPeriod;
            //   const startMonthVal = getFutureMonth(
            //     currentMonthNumber,
            //     numberOfMonthsVal
            //   );

            //   setStartMonth(startMonthVal);
            //   setNumberOfMonths(numberOfMonthsVal);
            //   setBillPeriod(billPeriodVal);

            //   const generatedPeriods = await generateBillingPeriods(
            //     startMonthVal,
            //     numberOfMonthsVal,
            //     billPeriodVal,
            //     billingStatementData
            //   );

            //   if (
            //     billingfilter.billingStartDate &&
            //     billingfilter.billingEndDate
            //   ) {
            //     const filterStartDate = moment(
            //       billingfilter.billingStartDate,
            //       "YYYY-MM-DD"
            //     ).valueOf();
            //     const filterEndDate = moment(
            //       billingfilter.billingEndDate,
            //       "YYYY-MM-DD"
            //     ).valueOf();

            //     const filteredData = generatedPeriods.filter((item) => {
            //       const itemStartDateMoment = moment(
            //         item.billingStart,
            //         "D/M/YYYY"
            //       );
            //       const itemStartDate = itemStartDateMoment.valueOf();

            //       const itemEndDateMoment = moment(item.billingEnd, "D/M/YYYY");
            //       const itemEndDate = itemEndDateMoment.valueOf();

            //       return (
            //         itemStartDate >= filterStartDate &&
            //         itemEndDate <= filterEndDate
            //       );
            //     });
          } else {
            setPeriods([]);
          }
          setBillingStatementLoading(false);
          // }
        } catch (error) {
          console.error("Error fetching billing details:", error);
        }
      })();
    } else {
      setIsBillingStatementSearch(false);
    }
  };

  useEffect(() => {
    getBillingStatementFilterList();
  }, [filter.userId, filter.projectId]);

  useEffect(() => {
    if (!openFilter && applyFilterFlag) {
      getBillingStatementFilterList();
    }
  }, [applyFilterFlag, openFilter]);

  useEffect(() => {
    getBillingStatementFilterList();
  }, [applyFilterFlag]);

  useEffect(() => {
    dispatch(getAllCustomersList());
    setTimeout(() => {
      setBillingStatementLoading(false);
    }, 2000);
    if (
      userListSel &&
      JSON.parse(userListSel).data &&
      JSON.parse(userListSel).data.length > 0
    ) {
      setUserList(JSON.parse(userListSel).data && JSON.parse(userListSel).data);
    }
  }, [userListSel, dispatch]);

  useEffect(() => {
    const loadData = async () => {
      // setBillingStatementLoading(true); // Start loading
      try {
        // Nested async function to handle fetching of customers
        const fetchData = async () => {
          try {
            if (reduxFilter?.userId && !filter?.userId) {
              await getProjectList(reduxFilter?.userId);
              setFilter((prevFilter) => ({ ...prevFilter, ...reduxFilter }));
              dispatch({
                type: types.ADMIN_BILLING_STATEMENT_SELECT,
                payload: reduxFilter,
              });
              setBillingFilter((prevFilter) => ({
                ...prevFilter,
                ...reduxFilter.filterValues,
              }));
            } else {
              setBillingFilter(billingfilter);

              // dispatch({
              //   type: types.ADMIN_BILLING_STATEMENT_SELECT,
              //   payload: {...reduxFilter}
              // })
            }
          } catch (error) {
            console.error(
              "An error occurred while fetching customer data:",
              error
            );
          }
        };

        await fetchData(); // Call fetchData after getDashboardFilterBroker completes
      } catch (error) {
        console.error(
          "An error occurred while fetching dashboard filter:",
          error
        );
      } finally {
        // setBillingStatementLoading(false); // End loading
      }
    };

    loadData();
  }, [reduxFilter, dispatch, filter.userId]);
  // useEffect(() => {
  //   if(filter.projectId){
  //     dispatch(getPerDiemList(filter.projectId))
  //   }
  // }), [filter.projectId];

  // useEffect(() => {
  //   getProjectList(reduxFilter.userId)
  // }), [reduxFilter.userId];

  useEffect(() => {
    handleCustomerProjectStatusChange("customerStatus", "all");
  }, []);

  const userRoles = getLogUserRole();

  const testing1 =
    (userRoles.includes("Admin") && userRoles.includes("Broker")) ||
    userRoles.includes("Admin")
      ? "3"
      : "0";

  const sortedLocationList = useMemo(() => {
    console.log(
      billingStateOrderBy,
      "orderauuuuuuuuuuuuuuuuuuuu",
      billingStateOrder
    );

    if (billingStateOrderBy) {
      return [...periods].sort((a, b) => {
        // Check if sorting by date field
        if (billingStateOrderBy === "BrokerName") {
          const valueA = a[billingStateOrderBy]?.toLowerCase() || ""; // Handle null or undefined as an empty string
          const valueB = b[billingStateOrderBy]?.toLowerCase() || ""; // Handle null or undefined as an empty string

          if (billingStateOrder === "asc") {
            // For ascending, valueA should be less than valueB for -1
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            // For descending, valueA should be greater than valueB for -1
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        } else if (
          billingStateOrderBy === "hours" ||
          billingStateOrderBy === "DayRate" ||
          billingStateOrderBy === "MileageRate" ||
          billingStateOrderBy === "Miles" ||
          billingStateOrderBy === "PerDiem" ||
          billingStateOrderBy === "StatusID"
        ) {
          const valueA = parseFloat(a[billingStateOrderBy]) || 0.0;
          const valueB = parseFloat(b[billingStateOrderBy]) || 0.0;
          console.log(valueA, valueB, "valueA - valueB", a, b);
          return billingStateOrder === "asc"
            ? valueA - valueB
            : valueB - valueA;
        }
        // Handle string fields and treat null/undefined as "0.00"
        else {
          const valueA =
            a[billingStateOrderBy] !== null &&
            a[billingStateOrderBy] !== undefined
              ? a[billingStateOrderBy].toString().toLowerCase()
              : "0.00";
          const valueB =
            b[billingStateOrderBy] !== null &&
            b[billingStateOrderBy] !== undefined
              ? b[billingStateOrderBy].toString().toLowerCase()
              : "0.00";

          if (billingStateOrder === "asc") {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        }
      });
    }
    // Return original list if no sorting criteria provided
    return periods;
  }, [periods, billingStateOrderBy, billingStateOrder]);

  console.log(sortedLocationList, "sortteeeeeeeeeeeeee");
  const handleLocationSortRequest = (property) => {
    const isAsc =
      billingStateOrderBy === property && billingStateOrder === "asc";
    const isDesc =
      billingStateOrderBy === property && billingStateOrder === "desc";
    console.log(
      billingStateOrder,
      "billingStateOrderbillingStateOrder",
      billingStateOrderBy,
      property
    );
    if (isDesc) {
      // Reset sorting
      setBillingStateOrder("");
      setBillingStateOrderBy("");
      dispatch({
        type: types.SORT_PARAMS,
        payload: { order: "", orderBy: "" },
      });
    } else {
      // Toggle sorting
      setBillingStateOrder(isAsc ? "desc" : "asc");
      setBillingStateOrderBy(property);
      dispatch({
        type: types.SORT_PARAMS,
        payload: { order: isAsc ? "desc" : "asc", orderBy: property },
      });
    }
  };

  const getLocationSortIcon = (orderByValue) => {
    if (billingStateOrderBy === orderByValue) {
      return billingStateOrder === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  useEffect(() => {
    if (currentSort) {
      setBillingStateOrder(currentSort.order);
      setBillingStateOrderBy(currentSort.orderBy);
    }
  }, [currentSort]);
  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={testing1} />

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar
            title="Orphaned Billing Statement"
            backFlag={false}
            backRoute={""}
          />
          <BillingStatementMenu getLogUserRole={getLogUserRoleArray} />
          {/* Filter Section */}
          <Box className="secound-bg-box user-log">
            <Grid container>
              <Grid sx={{ mb: "10px" }} xs={12} md={12}>
                <Stack
                  sx={{ float: { xs: "left", sm: "right" } }}
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing={2}
                >
                  <Link
                    to={{
                      pathname: ADMIN_BILLING_HISTORY,
                    }}
                  >
                    <Button
                      startIcon={
                        <span class="material-symbols-outlined">person</span>
                      }
                      className="secondary-btn"
                      variant="contained"
                    >
                      Orphaned History
                    </Button>
                  </Link>
                </Stack>
              </Grid>
              <Grid
                sx={{
                  pr: { xs: "0", md: "30px" },
                  opacity: billingStatmentLoading == true ? 0.5 : 1, // Reduce opacity to indicate disabled state
                  pointerEvents:
                    billingStatmentLoading == true ? "none" : "auto",
                }}
                xs={12}
                md={6}
              >
                {/* Customer Status */}
                <Box className="billing-active-checkbox">
                  <p style={{ marginBottom: "0px" }} className="label oh-label">
                    Customer
                  </p>
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "all"
                          )
                        }
                        checked={filter.customerStatus === "" ? true : false}
                        sx={{ color: "gray" }}
                        disabled={billingStatmentLoading == true}
                      />
                    }
                    label="All"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "yes"
                          )
                        }
                        checked={filter.customerStatus === true ? true : false}
                        sx={{ color: "gray" }}
                        disabled={billingStatmentLoading == true}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "no"
                          )
                        }
                        checked={filter.customerStatus === false ? true : false}
                        sx={{ color: "gray" }}
                        disabled={billingStatmentLoading == true}
                      />
                    }
                    label="Inactive"
                  />
                </Box>
                {/* Select Customer */}
                <FormControl
                  sx={{ width: "100%" }}
                  variant="standard"
                  disabled={billingStatmentLoading} // Apply the disabled state to FormControl
                >
                  <Autocomplete
                    sx={{
                      width: "100%",
                      fontSize: "14px !important",
                      // "& .MuiAutocomplete-inputRoot": {
                      //   paddingRight: "10px !important",
                      // },
                      "& .MuiAutocomplete-input": {
                        color: "#212121 !important",
                        fontSize: "14px !important",
                        // height: '25px !important'
                      },
                    }}
                    options={userList || []}
                    getOptionLabel={(option) => option.Name}
                    onChange={(event, value) =>
                      handleFilterChange(event, value?.UserId)
                    }
                    value={
                      userList.find((user) => user.UserId === filter.userId) ||
                      null
                    }
                    loading={billingStatmentLoading}
                    disableClearable
                    clearOnEscape={false} // Ensure the value doesn't reset when pressing escape
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search Customer"
                        sx={{
                          height: "25px !imporatant",
                          color: "#212121 !important",
                          fontSize: "14px !important",
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {/* {billingStatmentLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null} */}
                              {params.InputProps.endAdornment}
                              {filter.userId && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => {
                                      // Reset projectId when remove button is clicked
                                      setFilter((prevState) => ({
                                        ...prevState,
                                        userId: "",
                                        projectId: "",
                                        filterValues: {},
                                      }));
                                      dispatch({
                                        type: types.ADMIN_BILLING_STATEMENT_SELECT,
                                        payload: {
                                          ...filter,
                                          userId: "",
                                          projectId: "",
                                          filterValues: {},
                                        },
                                      });
                                    }}
                                  >
                                    <HighlightOffIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              )}
                            </>
                          ),
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.UserId === value.UserId
                    }
                    renderOption={(props, option) => (
                      <li
                        style={{
                          color: "#212121 !important",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                        {...props}
                        key={option.UserId}
                      >
                        {option.Name}
                      </li>
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid
                sx={{
                  pl: { xs: "0", md: "30px" },
                  opacity:
                    billingStatmentLoading == true || filter?.userId === ""
                      ? 0.5
                      : 1, // Reduce opacity to indicate disabled state
                  pointerEvents:
                    billingStatmentLoading == true || filter?.userId === ""
                      ? "none"
                      : "auto", // Prevent interaction
                }}
                xs={12}
                md={6}
              >
                {" "}
                <Box
                  sx={{ mt: { xs: "10px", sm: "0px" } }}
                  className="billing-active-checkbox"
                >
                  <p style={{ marginBottom: "0px" }} className="label oh-label">
                    Project
                  </p>
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "all"
                          )
                        }
                        checked={filter.projectStatus === "" ? true : false}
                        sx={{ color: "gray" }}
                        disabled={
                          billingStatmentLoading == true ||
                          filter?.userId === ""
                        } // Conditionally disable
                      />
                    }
                    label="All"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "yes"
                          )
                        }
                        checked={filter.projectStatus === true ? true : false}
                        sx={{ color: "gray" }}
                        disabled={
                          billingStatmentLoading == true ||
                          filter?.userId === ""
                        } // Conditionally disable
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "no"
                          )
                        }
                        checked={filter.projectStatus === false ? true : false}
                        sx={{ color: "gray" }}
                        disabled={
                          billingStatmentLoading == true ||
                          filter?.userId === ""
                        } // Conditionally disable
                      />
                    }
                    label="Inactive"
                  />
                </Box>
                {/* Select Project */}
                <FormControl
                  sx={{ width: "100%" }}
                  variant="standard"
                  disabled={
                    billingStatmentLoading == true || filter?.userId === ""
                  }
                >
                  <Autocomplete
                    sx={{
                      width: "100%",
                      fontSize: "14px !important",
                      // "& .MuiAutocomplete-inputRoot": {
                      //   paddingRight: "10px !important",
                      // },
                      "& .MuiAutocomplete-input": {
                        color: "#212121 !important",
                        fontSize: "14px !important",
                        // height: '25px !important'
                      },
                    }}
                    options={projectList || []}
                    getOptionLabel={(option) => option.Name}
                    onChange={(event, value) =>
                      handleFilterChange1(event, value)
                    }
                    value={
                      projectList.find(
                        (project) => project.ProjectId === filter.projectId
                      ) || null
                    }
                    loading={billingStatmentLoading}
                    disableClearable
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Search Project"
                        sx={{
                          height: "25px !imporatant",
                          color: "#212121 !important",
                          fontSize: "14px !important",
                        }}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {/* {billingStatmentLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null} */}
                              {params.InputProps.endAdornment}
                              {filter.projectId && (
                                <InputAdornment position="end">
                                  <IconButton
                                    size="small"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => {
                                      // Reset projectId when remove button is clicked
                                      setFilter((prevState) => ({
                                        ...prevState,
                                        projectId: "",
                                        filterValues: {},
                                      }));
                                      dispatch({
                                        type: types.ADMIN_BILLING_STATEMENT_SELECT,
                                        payload: {
                                          ...filter,
                                          projectId: "",
                                          filterValues: {},
                                        },
                                      });
                                    }}
                                  >
                                    <HighlightOffIcon fontSize="small" />
                                  </IconButton>
                                </InputAdornment>
                              )}
                            </>
                          ),
                        }}
                      />
                    )}
                    isOptionEqualToValue={(option, value) =>
                      option.ProjectId === value.ProjectId
                    }
                    renderOption={(props, option) => (
                      <li
                        style={{
                          color: "#212121 !important",
                          fontSize: "14px",
                          fontWeight: 400,
                        }}
                        {...props}
                        key={option.ProjectId}
                      >
                        {option.Name}
                      </li>
                    )}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* Display Billing Periods */}
          {billingStatmentLoading ? (
            <Box
              sx={{ background: "#fff", padding: "25px 24px", mt: "15px" }}
              className="secound-bg-box user-log"
            >
              <Grid container>
                <Grid xs={12} md={12} colSpan={7} align="center">
                  <CircularProgress disableShrink />
                </Grid>
              </Grid>
            </Box>
          ) : isBillingStatementSearch ? (
            <Box
              sx={{ background: "#fff", padding: "25px 24px", mt: "15px" }}
              className="secound-bg-box user-log"
            >
              <Grid container>
                <Grid xs={12} md={12}>
                  {/* Actions */}

                  <Stack
                    sx={{ float: "left", mt: "10px" }}
                    direction="row"
                    spacing={1}
                    alignItems="left"
                  >
                    <p style={{ mb: "0px" }} className="label oh-label">
                      Selected Project has {billPeriod} days Billing Period
                    </p>
                  </Stack>

                  <Stack
                    sx={{
                      float: { xs: "left", md: "right" },
                      alignItems: { xs: "flex-start", md: "center" },
                      marginTop: "0px",
                      marginBottom: "10px",
                    }}
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1}
                  >
                    {((reduxFilter?.filterValues?.billingStartDate ||
                      reduxFilter?.filterValues?.billingEndDate ||
                      reduxFilter?.filterValues?.broker?.length > 0) &&
                      applyFilterFlag) ||
                    reduxFilter?.filterValues?.billingStartDate ||
                    reduxFilter?.filterValues?.billingEndDate ||
                    reduxFilter?.filterValues?.broker?.length > 0 ? (
                      <Button
                        startIcon={
                          <span class="material-symbols-outlined">close</span>
                        }
                        className="clear-btn"
                        variant="contained"
                        onClick={clearBillingFilterFunc}
                      >
                        Clear Filter
                      </Button>
                    ) : (
                      ""
                    )}

                    {/* Filter Button */}
                    <Stack
                      className="filter"
                      sx={{ float: "right" }}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      onClick={filterOpenFun}
                    >
                      <span class="material-symbols-outlined">filter_list</span>
                      <Typography>Filter</Typography>
                    </Stack>
                  </Stack>

                  {/* Billing Periods Table */}
                  <TableContainer
                    className="billing-table"
                    sx={{ boxShadow: "none", maxHeight: 350 }}
                    component={Paper}
                  >
                    <Table
                      sx={{ minWidth: 650 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>Billing Period</TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "BrokerName"}
                              direction={
                                billingStateOrderBy === "BrokerName"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("BrokerName")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("BrokerName")
                              }
                              style={
                                billingStateOrderBy === "BrokerName"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Broker Name
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "Hours"}
                              direction={
                                billingStateOrderBy === "Hours"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("Hours")}
                              IconComponent={() => getLocationSortIcon("Hours")}
                              style={
                                billingStateOrderBy === "Hours"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Hours
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "DayRate"}
                              direction={
                                billingStateOrderBy === "DayRate"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("DayRate")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("DayRate")
                              }
                              style={
                                billingStateOrderBy === "DayRate"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Day Rate
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "Miles"}
                              direction={
                                billingStateOrderBy === "Miles"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() => handleLocationSortRequest("Miles")}
                              IconComponent={() => getLocationSortIcon("Miles")}
                              style={
                                billingStateOrderBy === "Miles"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Miles
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "MileageRate"}
                              direction={
                                billingStateOrderBy === "MileageRate"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("MileageRate")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("MileageRate")
                              }
                              style={
                                billingStateOrderBy === "MileageRate"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Mileage Rate
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "PerDiem"}
                              direction={
                                billingStateOrderBy === "PerDiem"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("PerDiem")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("PerDiem")
                              }
                              style={
                                billingStateOrderBy === "PerDiem"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Per Diem
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={billingStateOrderBy === "StatusID"}
                              direction={
                                billingStateOrderBy === "StatusID"
                                  ? billingStateOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("StatusID")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("StatusID")
                              }
                              style={
                                billingStateOrderBy === "StatusID"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Status
                            </TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {loading && <CustomPageLoading />}

                      <TableBody>
                        {console.log(periods, "peooeicdnkcnskcnsk")}
                        {sortedLocationList
                        .sort((a, b) => new Date(a.BillingStart) - new Date(b.BillingStart))
                        .map((period, index) => {
                          const currentDate = new Date();
                          const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed, so +1 is necessary
                          const currentYear = currentDate.getFullYear();
                          console.log(period, "ppeeeeeeeeeeeeeeeee");
                          return (
                            <TableRow
                              key={index}
                              onClick={() => billingMoveClick(period)}
                            >
                              <TableCell>
                                <span
                                 className={
                                  (currentYear > period.currentYear ||
                                    (currentYear === period.currentYear &&
                                      currentMonthNumber >
                                        period.currentMonth)) &&
                                  period.StatusID === 1
                                    ? "ribbon-box"
                                    : currentYear === period.currentYear &&
                                      currentMonthNumber ===
                                        period.currentMonth &&
                                      period.StatusID === 1
                                    ? "ribbon-box-active"
                                    : ""
                                }
                                >
                                  {`${moment
                                    .utc(period.BillingStart)
                                    .format("MM/DD/YYYY")} - ${moment
                                    .utc(period.BillingEnd)
                                    .format("MM/DD/YYYY")}`}

                                  {/* {period.billingDateList} */}
                                </span>
                              </TableCell>
                              <TableCell>{period.BrokerName}</TableCell>
                              <TableCell>
                                {period.Hours
                                  ? period.Hours.toFixed(2)
                                  : (0).toFixed(2)}
                              </TableCell>
                              <TableCell>
                                $
                                {period.DayRate
                                  ? period.DayRate.toFixed(2)
                                  : period.brokerDayRate
                                  ? period.brokerDayRate.toFixed(2)
                                  : (0).toFixed(2)}
                              </TableCell>
                              <TableCell>
                                {period.Miles ? period.Miles : 0}
                              </TableCell>
                              <TableCell>
                                $
                                {period.MileageRate
                                  ? period.MileageRate.toFixed(3)
                                  : (0).toFixed(3)}{" "}
                              </TableCell>
                              <TableCell>
                                $
                                {period.PerDiem
                                  ? period.PerDiem.toFixed(2)
                                  : (0).toFixed(2)}{" "}
                              </TableCell>
                              <TableCell>
                                {period.StatusID == 1 ? (
                                  <span className={"active-btn"}>
                                    Statement Open
                                  </span>
                                ) : (
                                  ""
                                )}
                                {period.StatusID == 2 ? (
                                  <span className={"closed-btn"}>
                                    Statement Closed
                                  </span>
                                ) : (
                                  ""
                                )}
                                {period.StatusID == 3 ? (
                                  <span className={"started-btn"}>
                                    Invoice Started
                                  </span>
                                ) : (
                                  ""
                                )}
                                {period.StatusID == 4 ? (
                                  <span className={"active-btn"}>
                                    Invoice Closed
                                  </span>
                                ) : (
                                  ""
                                )}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                    {/* <br />
                    {!loading && total > 0 && (
                      <Pagination
                        sx={{ mt: "15px", float: "right" }}
                        shape="rounded"
                        renderItem={(item) => (
                          <PaginationItem
                            components={{
                              previous: () => (
                                <Icon className="material-symbols-outlined">
                                  keyboard_backspace
                                </Icon>
                              ),
                              next: () => (
                                <Icon className="material-symbols-outlined">
                                  east
                                </Icon>
                              ),
                            }}
                            {...item}
                          />
                        )}
                        count={total}
                        page={page + 1}
                        onChange={handlePageChange}
                      />
                    )} */}
                  </TableContainer>
                  {!loading && periods && periods.length == 0 ? (
                    <NoRecordFound />
                  ) : (
                    <></>
                  )}

                  {/* Create Billing Confirm Dialog */}
                  {open && (
                    <CreateBillingConfirm
                      open={open}
                      createBilling={createBilling}
                    />
                  )}

                  {/* Billing Statement Filter */}
                  {openFilter && (
                    <AdminBillingStatementFilter
                      open={openFilter}
                      handleClose={filterClose}
                      filter={billingfilter}
                      setFilter={setBillingFilter}
                      setApplyFilterFlag={setApplyFilterFlag}
                      filterInitial={billingFilterInitial}
                      submitFilter={submitFilter}
                      billPeriod={billPeriod}
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
          ) : (
            !billingStatmentLoading && (
              <Box className="secound-bg-box user-log">
                <Grid container>
                  <Box
                    sx={{
                      textAlign: "center",
                      width: "100%",
                      background: "#fff",
                      marginTop: "15px",
                      borderRadius: "5px",
                    }}
                  >
                    <img
                      style={{ width: "100%", maxWidth: "326px" }}
                      src={BillingNodata}
                    />
                    <p
                      style={{ marginTop: "15px", marginBottom: "50px" }}
                      className="no-data-text"
                    >
                      Please select a{" "}
                      <span style={{ color: "#58A84A" }}>customer</span> and{" "}
                      <span style={{ color: "#58A84A" }}>project</span> to view
                      the orphaned statements.
                    </p>
                  </Box>
                </Grid>
              </Box>
            )
          )}
        </Box>
      </Box>
    </>
  );
};

export default AdminBillingList;
